import React from 'react'
import _, { assign, compact, each, filter, find, isEmpty, isNil, isUndefined, map } from 'lodash'
import Select from 'react-select'
import PropTypes from 'prop-types'
import {
  Card,
  ButtonContainer,
  Button,
  FormInput,
  FormInputSelect,
  FormInputTextArea,
  Row,
  Col,
  Alert,
  DetailList
} from 'camino-react'

import AssociatedTicketContent from 'Components/Problems/AssociatedTickets/AssociatedTicketContent'
import { cloudhelpPost } from 'Utilities/CloudHelp'
import CSIForm from '../CSI/CSIForm'

class NewProblem extends React.Component {
  constructor (props) {
    super(props)

    const { currentUser } = props

    this.state = {
      fields: {
        creator_id: currentUser.id,
        priority: '',
        category_id: '',
        datacentre_id: '',
        problem_manager_id: '',
        issue: '',
        root_cause: '',
        business_impact: '',
        corrective_action: '',
        preventive_action: '',
        outcome: '',
        status: 'open'
      },
      submitButton: {
        disabled: false,
        text: 'Create Problem'
      },
      associatedTicketSelections: [],
      csi: [],
      technicalEngineers: [],
      errors: []
    }

    this.policy = this.policy.bind(this)
    this.submit = this.submit.bind(this)
    this.addTicket = this.addTicket.bind(this)
    this.setTicket = this.setTicket.bind(this)
    this.removeTicket = this.removeTicket.bind(this)
    this.handleFieldValue = this.handleFieldValue.bind(this)
  }

  setTicket (index, ticketId) {
    this.setState((prevState) => {
      const { associatedTicketSelections: previous } = prevState

      const associatedTicketSelections = [...previous]
      associatedTicketSelections[index] = ticketId

      return { associatedTicketSelections }
    })
  }

  getFieldErrorClasses (field) {
    const { fieldsWithErrors } = this.state

    if (_.includes(fieldsWithErrors, field)) {
      return ('error')
    }

    return ''
  }

  handleFieldValue = (fieldName, value) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign({}, fields, { [fieldName]: value })
      return (
        { fields: newFields }
      )
    })
  }

  addTicket (ticketId) {
    this.setState((prevState) => {
      const { associatedTicketSelections: previous } = prevState

      const associatedTicketSelections = [...previous, ticketId]

      return { associatedTicketSelections }
    })
  }

  removeTicket (index) {
    this.setState((prevState) => {
      const { associatedTicketSelections: previous } = prevState

      const associatedTicketSelections = [...previous]
      associatedTicketSelections.splice(index, 1)

      return { associatedTicketSelections }
    })
  }

  policy (...args) {
    const { policies } = this.props

    return _.get(policies, args)
  }

  submit () {
    const { paths } = this.props
    const { problemsPath } = paths
    const {
      fields,
      associatedTicketSelections,
      csi,
      technicalEngineers
    } = this.state

    const {
      creator_id,
      priority,
      category_id,
      datacentre_id,
      issue,
      root_cause,
      business_impact,
      corrective_action,
      preventive_action,
      outcome,
      problem_manager_id
    } = fields

    this.setState({
      submitButton: {
        disabled: true,
        text: 'Creating Problem'
      }
    })

    const csiFields = ['owner_id', 'description', 'due_date']
    const csiErrors = map(csi, (csiObj, index) => {
      const emptyFields = []
      each(csiFields, (field) => { if (!csiObj[field] || csiObj === '') { emptyFields.push(field) } })

      if (!isEmpty(emptyFields)) { return { index, errors: emptyFields } }
    })

    if (!isEmpty(compact(csiErrors))) {
      this.setState({
        alert: {
          text: 'Please fill in the required fields',
          type: 'error'
        },
        submitButton: {
          disabled: false,
          text: 'Create Problem'
        },
        errors: csiErrors
      })

      return null
    }

    const postData = {
      problem: {
        creator_id,
        priority,
        category_id,
        datacentre_id,
        issue,
        root_cause,
        business_impact,
        corrective_action,
        preventive_action,
        outcome,
        ticket_ids: associatedTicketSelections,
        csi,
        problem_manager_id,
        technical_engineer_ids: map(technicalEngineers, 'value')
      }
    }

    cloudhelpPost(problemsPath, postData)
      .then((response) => {
        this.setState({
          submitButton: {
            disabled: false,
            text: 'Problem Created'
          }
        })

        window.location.href = response.data.redirect_url
      })
      .catch((error) => {
        this.setState({
          alert: {
            text: 'Please fill in the required fields',
            type: 'error'
          },
          submitButton: {
            disabled: false,
            text: 'Create Problem'
          },
          errors: error.response.data.errors
        })
      })
  }

  render () {
    const {
      addTicket,
      removeTicket,
      submit,
      setTicket,
      policy
    } = this

    const {
      paths,
      priorities,
      categories,
      datacentres,
      userOptions,
      managers
    } = this.props

    const {
      alert,
      fields,
      errors,
      associatedTicketSelections,
      submitButton,
      csi,
      technicalEngineers
    } = this.state

    const { disabled: submitDisabled, text: submitText } = submitButton

    const { priority, category_id, problem_manager_id, technical_engineers, datacentre_id } = fields

    const { problemsPath } = paths

    const priorityOptions = _.map(priorities, priorityValue => (
      {
        value: priorityValue,
        label: _.capitalize(priorityValue)
      }))

    const selectedPriority = _.find(priorityOptions, { value: priority })
    const selectedCategory = _.find(categories, { value: category_id })
    const selectedDatacentre = _.find(datacentres, { value: datacentre_id })

    const textArea = key => ({
      value: fields[key],
      onValue: value => this.handleFieldValue(key, value),
      rows: '4',
      errors: _.includes(errors, key) && ['Check this field']
    })

    return (
      <Row>
        <Col>
          { alert && (
            <Alert alertType={alert.type}>
              {alert.text}
            </Alert>
          ) }
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Priority, issue and root cause',
                    content: 'Assign the priority, and describe the issue and cause of the problem'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card allowOverflow>
                <FormInput label="Priority">
                  <FormInputSelect
                    value={selectedPriority}
                    options={priorityOptions}
                    onValue={value => (this.handleFieldValue('priority', value))}
                    errors={_.find(errors, 'priority') && ['Check this field']}
                  />
                </FormInput>
                <FormInput label="Category">
                  <FormInputSelect
                    value={selectedCategory}
                    options={categories}
                    onValue={value => (this.handleFieldValue('category_id', value))}
                    errors={_.find(errors, 'category_id') && ['Check this field']}
                  />
                </FormInput>
                <FormInput label="Datacentre Location">
                  <FormInputSelect
                    value={selectedDatacentre}
                    options={datacentres}
                    onValue={value => (this.handleFieldValue('datacentre_id', value))}
                    errors={_.find(errors, 'datacentre_id') && ['Check this field']}
                  />
                </FormInput>
                <FormInput label="Issue">
                  <FormInputTextArea {...textArea('issue')} />
                </FormInput>
                <FormInput label="Root cause (optional)">
                  <FormInputTextArea {...textArea('root_cause')} />
                </FormInput>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Problem manager and technical engineers',
                    content: 'Assign problem manager, and specify technical engineers'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card allowOverflow>
                <FormInput label="Problem Manager">
                  <FormInputSelect
                    value={find(managers, { value: problem_manager_id })}
                    options={managers}
                    onValue={value => (this.handleFieldValue('problem_manager_id', value))}
                    errors={_.find(errors, 'problem_manager_id') && ['Check this field']}
                  />
                </FormInput>
                <FormInput label="Technical Engineers">
                  <FormInputSelect
                    isMulti
                    value={technicalEngineers}
                    options={userOptions}
                    onValue={value => this.setState({ technicalEngineers: value })}
                    errors={_.find(errors, 'technical_engineers') && ['Check this field']}
                  />
                </FormInput>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Corrective action and preventive action',
                    content: 'Describe the corrective action and preventive action, if known'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card>
                <FormInput label="Corrective action (optional)">
                  <FormInputTextArea {...textArea('corrective_action')} />
                </FormInput>
                <FormInput label="Preventive action (optional)">
                  <FormInputTextArea {...textArea('preventive_action')} />
                </FormInput>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Business impact',
                    content: 'Describe the business impact of problem'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card>
                <FormInput label="Business impact">
                  <FormInputTextArea {...textArea('business_impact')} />
                </FormInput>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Outcome',
                    content: 'Describe the outcome, if known'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card>
                <FormInput label="Outcome (optional)">
                  <FormInputTextArea {...textArea('outcome')} />
                </FormInput>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Associated tickets',
                    content: 'Please select the tickets associated with this problem'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card>
                <AssociatedTicketContent
                  policy={policy}
                  addTicket={addTicket}
                  removeTicket={removeTicket}
                  removeAssociatedTicketSelection={removeTicket}
                  setTicket={setTicket}
                  associatedTicketSelections={associatedTicketSelections}
                  paths={paths}
                />
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Continual service improvements',
                    content: 'Add CSI associated with this problem'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card allowOverflow>
                <CSIForm {...{ userOptions, csi, errors }} updateCSIState={value => this.setState({ csi: value })} />
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <ButtonContainer center spaced>
                <a href={problemsPath} className="button button--outline">
                  Cancel
                </a>
                <Button disabled={submitDisabled} onClick={() => submit()}>
                  {submitText}
                </Button>
              </ButtonContainer>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

NewProblem.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  policies: PropTypes.objectOf(PropTypes.object).isRequired,
  paths: PropTypes.shape({
    apiProblemsUnassignedTicketsPath: PropTypes.string.isRequired,
    problemsPath: PropTypes.string.isRequired
  }).isRequired
}

export default NewProblem
